export const bulkCalendarDrawer = {
  header: {
    eyebrow: "Edição em massa",
    title: "Calendário em massa",
    subtitle: "Feche, abra ou ajuste várias unidades de uma vez.",
  },
  actions: {
    close: {
      label: "Fechar datas",
      hint: "Aplica um bloqueio manual respeitando reservas e sincronização.",
    },
    open: {
      label: "Abrir datas",
      hint: "Reabre apenas os dias selecionados sem alterar o restante do bloqueio.",
    },
    price: {
      label: "Alterar preço",
      hint: "Atualiza o preço por noite para as datas e acomodações escolhidas.",
    },
    minStay: {
      label: "Estadia mínima",
      hint: "Defina o mínimo de noites por data em massa.",
    },
  },
  microcopy: {
    close: "Bloqueio manual",
    open: "Abertura parcial",
    price: "Tarifa por noite",
    minStay: "Noites mínimas",
  },
  step1: {
    title: "O que aplicar",
    hintEmpty: "Escolha uma ação para começar.",
  },
  step2: {
    title: "Onde aplicar",
    selectedCount: "{selected} de {total} selecionados",
    selectVisible: "Visíveis",
    selectAll: "Todas",
    clear: "Limpar",
    searchPlaceholder: "Buscar acomodação…",
    empty: "Nenhuma acomodação corresponde à sua busca.",
  },
  step3: {
    title: "Período e dias",
    datesInRange: "{count} data no período | {count} datas no período",
    from: "De",
    to: "Até",
    presetAll: "Todos",
    presetWeekdays: "Seg–Sex",
    presetWeekend: "Fim de semana",
  },
  step4: {
    closeReasonTitle: "Motivo do fechamento",
    availabilityTitle: "Disponibilidade",
    closeReasonHint: "Opcional — será salvo junto com o bloqueio.",
    availabilityHint: "As vendas ficam fechadas (stop-sell); a disponibilidade é mantida. Altere somente se quiser.",
    closeCommentPlaceholder: "ex.: manutenção ou uso do proprietário",
    availabilityPlaceholder: "Quartos à venda (vazio = manter)",
    openAvailabilityHint: "Reabre as vendas. Informe quantos quartos oferecer (vazio = manter o atual).",
    availabilityPlaceholderOpen: "Quartos à venda",
  },
  ratePlan: {
    title: "Tarifa a modificar",
    hint: "Este tipo tem várias tarifas. Escolha a quais aplicar {target}. As tarifas derivadas se ajustam automaticamente.",
    targetPrice: "o preço",
    targetMinStay: "a estadia mínima",
    default: "padrão",
    roomsCount: "{count} quarto | {count} quartos",
    multiUnitNote: "Será aplicado a todos os quartos que tiverem a tarifa escolhida.",
    fallbackName: "Tarifa",
  },
  price: {
    title: "Novo preço por noite",
    hint: "Será aplicado às datas, unidades e tarifas escolhidas.",
    mixedCurrencyWarning: "Selecione apenas acomodações com a mesma moeda.",
    placeholder: "Valor",
    placeholderCurrency: "Valor em {currency}",
    hintPercent: "Sobe ou desce o preço que cada noite já tem.",
    modeGroupLabel: "Tipo de alteração do preço",
    modeFixed: "Preço fixo",
    modeFixedHint: "O mesmo valor em todas as noites.",
    modePercent: "Percentagem",
    modePercentHint: "Sobre o preço de cada noite.",
    modeAmount: "Valor",
    modeAmountHint: "Somar ou subtrair em cada noite.",
    amountPlaceholder: "Ex. 10",
    amountHint: "Soma-se ao que cada noite já custa. Com o sinal − baixa.",
    percentPlaceholder: "Ex. 20",
    percentHint: "Cada noite é recalculada a partir do seu próprio preço. O sinal − faz descer (entre {min} % e {max} %).",
    toggleSign: "Alternar entre subir e descer",
    invalidPercent: "Introduza uma percentagem entre {min} % e {max} %, diferente de 0.",
  },
  minStay: {
    title: "Estadia mínima",
    hint: "Número mínimo de noites por data.",
    placeholder: "ex.: 2",
  },
  summary: {
    empty: "Selecione unidades e período.",
    unitOne: "unidade",
    unitMany: "unidades",
    dateOne: "data",
    dateMany: "datas",
    ready: "{propertyCount} {propertyLabel} · {dateCount} {dateLabel} prontos para aplicar.",
    nightOne: "noite",
    nightMany: "noites",
    readyPriceFixed: "{propertyCount} {propertyLabel} · vai colocar {price} {currency} em {dateCount} {nightLabel}.",
    readyPricePlus: "{propertyCount} {propertyLabel} · subirá {amount} {currency} o preço de {dateCount} {nightLabel}.",
    readyPriceMinus: "{propertyCount} {propertyLabel} · baixará {amount} {currency} o preço de {dateCount} {nightLabel}.",
    readyPriceUp: "{propertyCount} {propertyLabel} · vai subir {percent} % o preço de {dateCount} {nightLabel}.",
    readyPriceDown: "{propertyCount} {propertyLabel} · vai descer {percent} % o preço de {dateCount} {nightLabel}.",
  },
  footer: {
    cancel: "Cancelar",
    apply: "Aplicar alterações",
    applying: "Aplicando…",
  },
  weekdays: {
    mon: { short: "S", long: "Segunda-feira" },
    tue: { short: "T", long: "Terça-feira" },
    wed: { short: "Q", long: "Quarta-feira" },
    thu: { short: "Q", long: "Quinta-feira" },
    fri: { short: "S", long: "Sexta-feira" },
    sat: { short: "S", long: "Sábado" },
    sun: { short: "D", long: "Domingo" },
  },
  ownerBlockComment: "Bloqueado pelo proprietário",
};
